// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"143":"dcc3e953","154":"783e8428","204":"4754c5f1","232":"a9632ba3","336":"669da74f","509":"90a04e2c","975":"0154432f"}[chunkId] + ".chunk.css";
};